module.exports = __webpack_public_path__ + "static/media/pagos.05db99b7.svg";